import { Button } from "@pepperstone/pepper-ui-kit";
import { notify } from "@/components/toast/notify.ts";
import { useCopyToClipboard } from "@/hooks/useCopyToClipboard.ts";

type CopyToClipboardProps = {
  text: string;
  label: string;
};

export const CopyToClipboard = ({ text, label }: CopyToClipboardProps) => {
  const { copyToClipboard, isCopied } = useCopyToClipboard();

  const handleCopy = async () => {
    const success = await copyToClipboard(text);
    if (success) {
      notify.success(`${label} copied`);
    }
  };

  return (
    <Button
      variant="ps-btn-transparent"
      className="ps-text-icon-subdued ps-ms-auto"
      type="button"
      size="ps-btn-xs"
      icon={isCopied ? "check-mark" : "copy"}
      onClick={handleCopy}
      aria-label={`Copy ${label}`}
    />
  );
};
